import { getJSON, putJSON, Formatters, deleteJSON } from 'hb4e-ui-core'
import { List, ListType } from 'hb4e-ui-context'

const { getErrorsList, getErrorMessageFromPayload } = Formatters

export const putListAPI = async (list) => {
  try {
    const response = await putJSON(`/list/${list.id}`, list)

    return new List(response.data.list)
  } catch (errors) {
    throw getErrorsList(errors)
  }
}

export const putShareListAPI = async (listID, body) => {
  try {
    return await putJSON(`/list/${listID}/share`, body)
  } catch (error) {
    const errorMessage = getErrorMessageFromPayload(error)
    throw new Error(errorMessage)
  }
}

export const deleteListAPI = async (listID) => {
  try {
    return await deleteJSON(`/list/${listID}`)
  } catch (error) {
    const errorMessage = getErrorMessageFromPayload(error)
    throw new Error(errorMessage)
  }
}

export const deleteListItemAPI = async (listID, itemID) => {
  try {
    return await deleteJSON(`/list/${listID}/items/${itemID}`)
  } catch (error) {
    const errorMessage = getErrorMessageFromPayload(error)
    throw new Error(errorMessage)
  }
}

export const getPurchasedItemsListAPI = async () => {
  try {
    const response = await getJSON(`/list/by-type/${ListType.PURCHASED_ITEMS}`)

    return new List(response?.data?.list)
  } catch (error) {
    const errorMessage = getErrorMessageFromPayload(error) || 'Error fetching purchased items'
    throw new Error(errorMessage)
  }
}

export const putListSortOrderAPI = async (listID, items) => {
  const normalizedItems = items.map((item) => ({ sortOrder: item.sortOrder, id: item.id }))

  try {
    const response = await putJSON(`/list/${listID}/items/reorder`, { items: normalizedItems })

    return response
  } catch (error) {
    const errorMessage = getErrorMessageFromPayload(error)
    throw new Error(errorMessage)
  }
}
